/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Faq_State_VerifyInputs */

const en_directory_detail_faq_state_verify = /** @type {(inputs: Directory_Detail_Faq_State_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify on official site`)
};

const zh_directory_detail_faq_state_verify = /** @type {(inputs: Directory_Detail_Faq_State_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请在官网核验`)
};

/**
* | output |
* | --- |
* | "Verify on official site" |
*
* @param {Directory_Detail_Faq_State_VerifyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_faq_state_verify = /** @type {((inputs?: Directory_Detail_Faq_State_VerifyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Faq_State_VerifyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_faq_state_verify(inputs)
	return zh_directory_detail_faq_state_verify(inputs)
});
export { directory_detail_faq_state_verify as "directory.detail.faq_state_verify" }